import { withTheme } from 'styled-components'
import Gallery from './Gallery'

export default withTheme(Gallery)
